var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 50 50",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.7 3.6h-23.4c-1.3 0-2.3 1.1-2.3 2.4v40.7c0 1.3 1 2.3 2.3 2.3h23.4c1.3 0 2.3-1 2.3-2.3v-40.7c0-1.3-1-2.4-2.3-2.4z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 7.4h24.1v35.3h-24.1z",
    fill: "#98d0f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45.8,
    fill: "#525252",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 5.2h-5.7c-.2 0-.4.2-.4.4s.2.4.4.4h5.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.2 1c-9.8 0-17.8 5.8-17.8 13 0 3.9 2.3 7.3 6 9.7l-4 9.3c-.3.6.4 1.2 1 .8l11.4-7.2c1.1.2 2.3.2 3.4.2 9.8.1 17.8-5.7 17.8-12.8 0-7.2-8-13-17.8-13z",
    fill: "#ed7161"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.4 10.9c-.4 0-.8.1-1 .3-.3.2-.4.4-.4.8 0 .3.1.6.4.8s.8.4 1.7.6 1.5.5 1.9.9.7.9.7 1.7c0 .7-.3 1.3-.8 1.8-.6.5-1.3.7-2.2.7-1.3 0-2.5-.5-3.5-1.4l.9-1.1c.8.7 1.7 1.1 2.6 1.1.5 0 .8-.1 1.1-.3s.4-.5.4-.8-.1-.6-.4-.8-.7-.3-1.3-.5c-.6-.1-1.1-.3-1.4-.4s-.6-.3-.9-.5c-.5-.4-.7-1-.7-1.7 0-.8.3-1.4.8-1.8.6-.4 1.3-.6 2.1-.6.5 0 1.1.1 1.6.3s1 .4 1.4.7l-.8 1.1c-.2-.2-.6-.4-1-.6-.3-.2-.7-.3-1.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9 18.2h-1.4v-8.4h2.2l2.5 5.3 2.5-5.3h2.3v8.4h-1.4v-6.6l-2.9 5.8h-.8l-2.9-5.8v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.8 10.9c-.4 0-.8.1-1 .3-.3.2-.4.4-.4.8 0 .3.1.6.4.8s.8.4 1.7.6 1.5.5 1.9.9.7.9.7 1.7c0 .7-.3 1.3-.8 1.8-.6.5-1.3.7-2.2.7-1.3 0-2.5-.5-3.5-1.4l.9-1.1c.8.7 1.7 1.1 2.6 1.1.5 0 .8-.1 1.1-.3s.4-.5.4-.8-.1-.6-.4-.8c-.2-.2-.6-.4-1.2-.5s-1.1-.3-1.4-.4-.6-.3-.9-.5c-.5-.4-.7-1-.7-1.7 0-.8.3-1.4.8-1.8.6-.4 1.3-.6 2.1-.6.5 0 1.1.1 1.6.3s1 .4 1.4.7l-.8 1.1c-.2-.2-.6-.4-1-.6s-.8-.3-1.3-.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.7dd01026.svg";
export { ForwardRef as ReactComponent };